import React from 'react'; 
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { COLORS } from '../utils/Constants';

const MenuPopup = (props) => {
    
    let tabLanguages = props.tabLanguages;
    let rowLength = tabLanguages.length/4;
    let array1 = tabLanguages.slice(0, rowLength);
    let array2 = tabLanguages.slice(rowLength, 2*rowLength);
    let array3 = tabLanguages.slice(2*rowLength, 3*rowLength);
    let array4 = tabLanguages.slice(3*rowLength, 4*rowLength);

    return (
        <Row style={{ backgroundColor: COLORS.blueMenu }}>
          <Col span={6}>
          { array1.map((item, index) => {
              return  <p key={index} className="popOverItem" onClick={(e) => { props.loadMenu(item, true) }}>
                        <Link className="popOverItem" to={"/"+item.toLowerCase()}>{item}</Link>
                      </p>
          }) }
          </Col>
          <Col span={6}>
          { array2.map((item, index) => {
              return  <p key={index} className="popOverItem" onClick={(e) => { props.loadMenu(item, true) }}>
                        <Link className="popOverItem" to={"/"+item.toLowerCase()}>{item}</Link>
                      </p>
          }) }
          </Col>
          <Col span={6}>
          { array3.map((item, index) => {
              return  <p key={index} className="popOverItem" onClick={(e) => { props.loadMenu(item, true) }}>
                        <Link className="popOverItem" to={"/"+item.toLowerCase()}>{item}</Link>
                      </p>
          }) }
          </Col>
          <Col span={6}>
          { array4.map((item, index) => {
              return  <p key={index} className="popOverItem" onClick={(e) => { props.loadMenu(item, true) }}>
                        <Link className="popOverItem" to={"/"+item.toLowerCase()}>{item}</Link>
                      </p>
          }) }
          </Col>
      </Row>
    );
}
  
export default MenuPopup;